import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "splitbykey"
})
export class SplitByKeyPipe implements PipeTransform {
  constructor() { }
  transform(val: string, key: string): any {
    return val ? val.split(key).filter(x => x != undefined && x != null && x != "") : [];
  }
}
